import * as actions from '../actions/route-groups';
import * as models from '../../domain/models';

import * as _ from 'lodash';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  customShuttleRouteGroups: Array<models.CustomShuttleRouteGroups>;
}

const initialState: State = {
  isLoading: false,
  isLoaded: false,
  customShuttleRouteGroups: [],
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    }

    case actions.LOAD_SUCCESS: {
      const customShuttleRouteGroups = _.cloneDeep(action.payload);

      return {
        ...state,
        customShuttleRouteGroups,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getCustomShuttleRouteGroups = (state: State) => state.customShuttleRouteGroups;
